function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26,17.82V14.2H23.4a7.22,7.22,0,0,0-.88-2.13l1.81-1.85-2.5-2.55L20,9.51a7.82,7.82,0,0,0-2.13-.89V6H14.21V8.62a7.82,7.82,0,0,0-2.13.89L10.22,7.67,7.67,10.22l1.85,1.85a7.49,7.49,0,0,0-.88,2.13H6v3.62H8.64a7.43,7.43,0,0,0,.88,2.12L7.67,21.78l2.55,2.55,1.85-1.85a8,8,0,0,0,2.14.89V26h3.62V23.39A7.36,7.36,0,0,0,20,22.5l1.87,1.83,2.5-2.5L22.48,20a7.83,7.83,0,0,0,.89-2.11Zm-10,1.8A3.62,3.62,0,1,1,19.65,16,3.62,3.62,0,0,1,16,19.62Z",
    style: {
      fill: "#7c7c7c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.bfb9250c.svg";
export { ForwardRef as ReactComponent };